import React, {useContext} from 'react';
import {AppContext} from '../App';
import Colors from '../styles/colors';
import BottomNav from './bottomNav';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import useWindowSize from '../utils/windowResizeHook';
import {BASE_URL} from '../env.json';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/styles';

//set types
interface Props {
  message: string,
}

const ErrorComponent = React.memo((props: Props) => {
  const windowSize = useWindowSize();
  const context = useContext(AppContext);
  const devId = context.deviceId;

  const compStyle = makeStyles({
    fullHeight: {
      backgroundColor: Colors.white,
      paddingBottom: 100,
      height: '100%',
      overflow: 'scroll',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    card: {
      width: (windowSize.width > 450) ? 400 : '80%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 3, 
      backgroundColor: '#fff',
      boxShadow: '0 3px 4px -1px rgba(0, 0, 0, 0.2), 0 0 1px 0 rgba(0, 0, 0, 0.3)',
      padding: '25px 15px',
      textAlign: 'center',
    },
    icon: {
      fontSize: 70,
      color: Colors.orange,
    },
    button: {
      marginTop: 10,
      backgroundColor: Colors.yellow,
      padding: '10px 30px',
    }
  });

  const compStyles = compStyle();

  return (
      <div className={compStyles.fullHeight}>
        <div className={compStyles.card}>
          <FontAwesomeIcon icon={faExclamationTriangle} className={compStyles.icon} />
          <h2>{props.message}</h2>
          <Button
              variant="contained"
              className={compStyles.button}
              href={`${BASE_URL}userprofile/v4/contact-support/${devId}`}
          >
              Contact Support
          </Button>
        </div>
        <BottomNav />
      </div>
  );
});

export default ErrorComponent;